import React from "react";
import GroupRoutePremiumPage from "../components/GroupRoutePremiumPage";
import { groupServiceConfigs } from "../data/groupServiceConfigs";

const GroupServicePage = ({ serviceKey, variant = "minibus" }) => {
  const serviceEntry = groupServiceConfigs[serviceKey];

  if (!serviceEntry) return null;

  return (
    <GroupRoutePremiumPage
      variant={variant}
      route={serviceEntry.route}
      configs={serviceEntry.configs}
    />
  );
};

export default GroupServicePage;
